import { Item, SocialItem, PartherItem, PathMenuItem } from '../types/types';

//Components
import Arrow from '../components/Illustration/Arrow';
// import Basket from '../components/Illustration/Basket';
// import Camera from '../components/Illustration/Camera';
import CardItem from '../components/Illustration/Cards/CardItem/CardItem';
// import Chat from '../components/Illustration/Chat';
// import Education from '../components/Illustration/Education';
import Email from '../components/Illustration/Email';
import Flash from '../components/Illustration/Flash';
import Facebook from '../components/Illustration/Facebook';
import Flexible from '../components/Illustration/Cards/Flexible/Flexible';
// import GamepaMuted from '../components/Illustration/GamepaMuted';
// import Heart from '../components/Illustration/Heart';
// import Instagram from '../components/Illustration/Instagram';
// import Lighting from '../components/Illustration/Lighting';
import LightingMuted from '../components/Illustration/LightingMuted';
// import Like from '../components/Illustration/Like';
import Linkedin from '../components/Illustration/Linkedin';
// import Options from '../components/Illustration/Options';
import OptionsMuted from '../components/Illustration/OptionsMuted';
import Phone from '../components/Illustration/Phone';
import PhoneIcon from '../components/Illustration/PhoneIcon';
// import Puzzle from '../components/Illustration/Puzzle';
// import Rocket from '../components/Illustration/Rocket';
import RocketMuted from '../components/Illustration/RocketMuted';
// import Star from '../components/Illustration/Star';
import Telegram from '../components/Illustration/Telegram';
import Wallet from '../components/Illustration/Wallet';
// import WalletGood from '../components/Illustration/WalletGood';
import Whatsapp from '../components/Illustration/Whatsapp';

//SVG files
import Api from '../assets/img/Illustration/Api.svg';
import BasketColor from '../assets/img/Illustration/BasketColor.svg';
import CharityColor from '../assets/img/Illustration/CharityColor.svg';
import ChatColor from '../assets/img/Illustration/ChatColor.svg';
import ChartColor from '../assets/img/Illustration/ChartColor.svg';
import CloudColor from '../assets/img/Illustration/CloudColor.svg';
import EducationColor from '../assets/img/Illustration/EducationColor.svg';
import ExchangeColor from '../assets/img/Illustration/ExchangeColor.svg';
import GamepadColor from '../assets/img/Illustration/GamepadColor.svg';
import HeartColor from '../assets/img/Illustration/HeartColor.svg';
import HorecaColor from '../assets/img/Illustration/HorecaColor.svg';
import InstagramColor from '../assets/img/Illustration/InstagramColor.svg';
import LightingColor from '../assets/img/Illustration/LightingColor.svg';
import LikeColor from '../assets/img/Illustration/LikeColor.svg';
import OptionsColor from '../assets/img/Illustration/OptionsColor.svg';
// import Qiwi from '../assets/img/Partners/Qiwi.svg';
import RocketColor from '../assets/img/Illustration/RocketColor.svg';
import StreamColor from '../assets/img/Illustration/StreamColor.svg';
import TravelColor from '../assets/img/Illustration/TravelColor.svg';
import WalletColor from '../assets/img/Illustration/WalletColor.svg';

//Partners
import Advcash from '../assets/img/Partners/Advcash.svg';
// import Freedom from '../assets/img/Partners/Freedom.svg';
import Gmpays from '../assets/img/Partners/Gmpays.svg';
// import Mastercard from '../assets/img/Partners/Mastercard.svg';
import Pagsmile from '../assets/img/Partners/Pagsmile.svg';

import Swift from '../assets/img/Partners/Swift.svg';
import Sepa from '../assets/img/Partners/Sepa.svg';
// import TikTok from '../assets/img/Partners/TikTok.svg';
// import Visa from '../assets/img/Partners/Visa.svg';
// import Xiaomi from '../assets/img/Partners/Xiaomi.svg';
import PGS from '../assets/img/Partners/PGS.svg';

//Icons
import GearIcon from '../assets/img/Icons/Gear.svg';
import CardIcon from '../assets/img/Icons/Card.svg';
import CardsIcon from '../assets/img/Icons/Cards.svg';
import FlashIcon from '../assets/img/Icons/Flash.svg';
import PuzzleIcon from '../assets/img/Icons/Puzzle.svg';
import ShieldIcon from '../assets/img/Icons/Shield.svg';
// import WalletIcon from '../assets/img/Icons/Wallet.svg';

//Files
import Privacy from '../assets/files/Privacy_and_Cookies_Policy_Contact_Pay.pdf';

export const menuItems: PathMenuItem[] = [
  {
    id: 1,
    path: 'https://docs.contactpay.com/?lang=en',
    text: 'For Developers',
  },
  //   { id: 2, path: 'partners', text: 'For Partners' },
  //   { id: 3, path: 'pricing', text: 'Pricing' },
  //   { id: 4, path: 'faq', text: 'FAQ' },
  { id: 5, path: 'about', text: 'About us' },
  //   { id: 6, path: 'documents', text: 'Documents' },
  { id: 7, path: 'contacts', text: 'Contacts' },
];
export const extensionFilterData: Item[] = [
  {
    id: 1,
    text: 'E-commerce',
    default: false,
    img: BasketColor,
  },
  {
    id: 2,
    text: 'Online gaming',
    default: true,
    img: GamepadColor,
  },
  {
    id: 3,
    text: 'EdTech',
    default: false,
    img: EducationColor,
  },
  {
    id: 4,
    text: 'FinTech',
    default: false,
    img: WalletColor,
  },
  {
    id: 5,
    text: 'Travel',
    default: false,
    img: TravelColor,
  },
  {
    id: 6,
    text: 'SaaS providers',
    default: false,
    img: CloudColor,
  },
  {
    id: 7,
    text: 'Content developers',
    default: false,
    img: InstagramColor,
  },
  {
    id: 8,
    text: 'HoReCa',
    default: false,
    img: HorecaColor,
  },
  {
    id: 9,
    text: 'Live streaming',
    default: false,
    img: StreamColor,
  },
  {
    id: 10,
    text: 'Online dating',
    default: false,
    img: HeartColor,
  },
  {
    id: 11,
    text: 'Charity funds',
    default: false,
    img: CharityColor,
  },
  {
    id: 12,
    text: 'Marketing and CPA',
    default: false,
    img: LikeColor,
  },
];
export const listConectItems: Item[] = [
  { id: 1, text: 'Lightning-fast payments', img: FlashIcon },
  { id: 2, text: 'Multi currency options', img: CardsIcon },
  { id: 3, text: 'Easy API integration', img: PuzzleIcon },
  { id: 4, text: 'Quick funds availability', img: CardIcon },
  { id: 5, text: 'Increased security', img: ShieldIcon },
  { id: 6, text: 'Online customer support', img: GearIcon },
];
export const listOptionsItems: Item[] = [
  {
    id: 1,
    title: 'Bank cards — ',
    text: 'get paid online through debit or credit cards',
    svg: <Flash />,
  },
  {
    id: 2,
    title: 'Bank accounts — ',
    text: 'direct payments through bank transfer',
    svg: <Arrow />,
  },
  {
    id: 3,
    title: 'E-wallets & QRs — ',
    text: 'effortless way to receive online payments',
    svg: <Wallet />,
  },
  {
    id: 4,
    title: 'Web payments — ',
    text: 'payment processing via web or mobile app',
    svg: <Phone />,
  },
];
export const listSolutionsItems: Item[] = [
  {
    id: 1,
    title: 'PayOut',
    text: 'To cards and e-wallets, web-based with no integration',
    img: WalletColor,
  },
  {
    id: 2,
    class: 'card-item',
    title: 'Mass payouts',
    text: 'Using single API and manually',
    svg: <CardItem />,
  },
  {
    id: 3,
    title: 'Flexible solutions',
    text: 'Traditional fiat or crypto settlements available',
    svg: <Flexible />,
  },
  {
    id: 4,
    title: 'Customized pay form',
    text: 'Use our solution or your own webform',
    img: OptionsColor,
  },
  {
    id: 5,
    title: 'Single integration',
    text: 'Easy to integrate REST API with online support',
    button: 'Apply for API',
    img: Api,
  },
  {
    id: 6,
    title: 'Quick funds availability ',
    text: 'Minimal time lag from client’s payment',
    img: LightingColor,
  },
];
export const tabsBenefistsItems: Item[] = [
  {
    id: 1,
    title: 'Fast and Secure',
    activeTitle: 'Fast and Secure Transactions',
    text: 'Our platform ensures that your payments are processed quickly and securely',
  },
  {
    id: 2,
    title: 'Competitive Rates',
    activeTitle: 'Competitive Exchange Rates',
    text: 'Our exchange rates are among the most competitive in the market',
  },
  {
    id: 3,
    title: 'Wide Payment Methods',
    activeTitle: 'Wide Range of Payment Methods',
    text: 'We offer a variety of payment methods, including credit/debit cards, bank transfers, and e-wallets',
  },
  {
    id: 4,
    title: 'Wide Reach',
    activeTitle: 'Wide Payment Methods',
    text: 'We have partnerships with banks and payment providers in 20+ countries around the world, giving you access to a truly wide range of customers in the local markets',
  },
  {
    id: 5,
    title: 'Local Compliance',
    activeTitle: 'Compliance with Local Regulations',
    text: 'Our compliance with local regulations ensures that your transactions are compliant with all applicable laws and regulations',
  },
  {
    id: 6,
    title: 'Online Support',
    activeTitle: 'Online Customer Support',
    text: 'Our dedicated customer support team is available around the clock to assist with any issues or questions you may have',
  },
];
export const partners: PartherItem[] = [
  { id: 1, title: 'Swift', img: Swift },
  { id: 2, title: 'Sepa', img: Sepa },
  { id: 3, title: 'Advcash', img: Advcash },
  { id: 4, title: 'Visa', img: Gmpays },
  { id: 5, title: 'Swift', img: Pagsmile },
  //   { id: 6, title: 'Freedom', img: Freedom },
  { id: 7, title: 'PGS', img: PGS },
];
export const socialItems: SocialItem[] = [
  //   {
  //     id: 1,
  //     title: '+44 000 000 00',
  //     name: '+4400000000',
  //     icon: '',
  //     href: `tel:`,
  //   },
  {
    id: 2,
    title: 'E-mail',
    name: 'sales@contactpay.com',
    href: `mailto:`,
    subject: `?subject=Request from ContactPay's website`,
    svg: <Email />,
  },
  {
    id: 3,
    title: 'Facebook',
    href: 'https://www.linkedin.com/company/contactpay-solutions/',
    svg: <Facebook />,
  },
  {
    id: 4,
    title: 'Linkedin',
    href: 'https://www.linkedin.com/company/contactpay-solutions/',
    svg: <Linkedin />,
  },
];
export const connectionItems: SocialItem[] = [
  //   {
  //     id: 1,
  //     title: 'E-mail',
  //     name: 'sales@contactpay.com',
  //     href: `mailto:`,
  //     subject: `?subject=Request from ContactPay's website`,
  //     svg: <Email />,
  //   },
  {
    id: 2,
    title: 'Linkedin',
    href: 'https://www.linkedin.com/company/contactpay-solutions/',
    svg: <Linkedin />,
  },
  {
    id: 3,
    title: 'Facebook',
    href: 'https://www.linkedin.com/company/contactpay-solutions/',
    svg: <Facebook />,
  },
  {
    id: 4,
    title: 'Telegram',
    href: 'https://t.me/',
    svg: <Telegram />,
  },
];
export const supportTeamItems: SocialItem[] = [
  {
    id: 1,
    insert: true,
    title: 'E-mail',
    name: 'sales@contactpay.com',
    href: `mailto:`,
    subject: `?subject=Request from ContactPay's website`,
    svg: <Email />,
  },
  {
    id: 2,
    insert: true,
    title: 'Whatsapp',
    href: 'https://www.facebook.com/',
    svg: <Whatsapp />,
  },
  {
    id: 3,
    insert: true,
    title: 'Telegram',
    href: 'https://t.me/',
    svg: <Telegram />,
  },
];
export const choiceItems: SocialItem[] = [
  {
    id: 1,
    insert: true,
    title: 'Phone',
    svg: <PhoneIcon />,
  },
  {
    id: 2,
    insert: true,
    title: 'E-mail',
    svg: <Email />,
  },
  {
    id: 3,
    insert: true,
    title: 'Whatsapp',
    svg: <Whatsapp />,
  },
  {
    id: 4,
    insert: true,
    title: 'Telegram',
    svg: <Telegram />,
  },
];
export const paymentsItems: Item[] = [
  {
    id: 1,
    title: 'Our mission',
    text: 'Is to help businesses around the globe to connect to the digital economy, receive payments easily in any local country and currency, while keeping costs low and ensuring compliance with local regulations, and without having to set up local entities.',
    img: RocketColor,
  },
  {
    id: 2,
    title: 'We believe',
    text: 'That payment processing should be seamless and effortless, and our team is dedicated to providing the best payment solutions to meet your business needs.',
    img: ExchangeColor,
  },
  {
    id: 3,
    title: 'We achieve',
    text: 'This by enabling businesses to easily launch and manage local payment methods in new countries, supporting their expansion efforts with modern and reliable infrastructure, expertise, and exceptional customer service.',
    img: LightingColor,
  },
  {
    id: 4,
    title: 'We are proud',
    text: 'Of what we do, and we are committed to helping our clients succeed. Whether you are a start-up looking to expand your operations or an established business seeking to streamline your payment processes, we have the expertise and solutions to help you achieve your goals',
    img: ChartColor,
  },
];
export const startedItems: Item[] = [
  {
    id: 1,
    title: 'Talk to sales',
    text: 'Talk to sales to discuss the unique aspects of your business and receive personalized offers with the best deal terms.',
    img: ChatColor,
  },
  {
    id: 2,
    title: 'Explore APIs',
    text: 'Explore APIs to understand its functionality and integration options, or reach out to your sales manager for assistance.',
    img: OptionsColor,
  },
  {
    id: 3,
    title: 'Pass KYB',
    text: 'Pass KYB to get verified, provide a limited number of information about your business to comply with regulations.',
    img: LikeColor,
  },
  {
    id: 4,
    title: 'Get started',
    text: 'Sign an agreement and integrate new possibilities for global payments, simplify purchase for your customers.',
    img: RocketColor,
  },
];
export const featuresItems: Item[] = [
  {
    id: 1,
    title: 'Payment Processing ',
    list: [
      { id: 1, text: 'International Transactions' },
      { id: 2, text: 'Various Payment Methods' },
      { id: 3, text: 'One-click Payments' },
      { id: 4, text: 'Adaptive Payform' },
    ],
    svg: <RocketMuted />,
  },
  {
    id: 2,
    title: 'Merchant’s Account',
    list: [
      { id: 1, text: 'Account Management' },
      { id: 2, text: 'Card Funds Holding' },
      { id: 3, text: 'Free Chargebacks' },
      { id: 4, text: 'Quick funds availability' },
    ],
    svg: <LightingMuted />,
  },
  {
    id: 3,
    title: 'Invoicing and Billing ',
    list: [
      { id: 1, text: 'Online Invoices ' },
      { id: 2, text: 'Payment Links' },
      { id: 3, text: 'Recurring Payments' },
      { id: 4, text: 'Payment Splitting' },
    ],
    svg: <OptionsMuted />,
  },
];
export const aboutItems: Item[] = [
  {
    id: 1,
    text: 'We are committed to providing businesses of all sizes with the best  possible solutions for their payment needs. Our international team has a wealth of experience in the global payments and fintech fields, which we leverage to help our partners scale their operations and our clients reach more customers.',
  },
  {
    id: 2,
    text: 'We understand the challenges and unique needs that businesses face when expanding to new markets when it comes to payments, and we are dedicated to providing the tools, solutions, and expertise needed to navigate the complex world of international payments. Contact us to learn more about how we can help your business succeed in the global marketplace.',
  },
];
export const connectionTexts: Item[] = [
  {
    id: 1,
    text: 'We are here to help you grow your business by providing world-class online payment solutions with a single API integration. Our team of experts has extensive experience in the payments and fintech industries, and we are dedicated to helping our partners scale their operations, and our clients reach and serve more customers.',
  },
  {
    id: 2,
    text: `If you have any questions about our services, terms of cooperation or would like to learn more about how we can help your business succeed, please don't hesitate to contact us.`,
  },
];
export const socialMediaItems: Item[] = [
  {
    id: 1,
    title: 'Social Media',
    text: 'Join our community to learn new things about the possibilities of growing your business, and expanding your local and international reach.',
    img: LikeColor,
  },
];
export const addressItems: Item[] = [
  {
    id: 1,
    text: 'ContactPay Solution LTD is a legal entity registered in the United Kingdom with the company number 12149419.',
    href: '',
  },
  {
    id: 2,
    text: 'Registration address: Mazars, 30 Old Bailey, London, United Kingdom, EC4M 7AU.',
    href: '',
  },
  {
    id: 3,
    text: 'ContactPay is authorized and regulated by the Financial Conduct Authority as an Electronic Money Institution with the reference number',
    texthref: '901065.',
    href: 'https://register.fca.org.uk/s/firm?id=0010X00004ijEuKQAU',
  },
];
export const cookieItems: Item[] = [
  {
    id: 1,
    text: `This website uses cookies in order to offer you the most relevant information and convenient browsing.`,
  },
  {
    id: 2,
    text: `The cookies can remember your settings and the data you fill in on web-forms on our website and analyze the website’s traffic, including how you found us and collect information about your browsing on the website. You can read more at`,
    texthref: 'Cookie Policy',
    href: Privacy,
  },
  {
    id: 3,
    text: `and can change your settings. Please accept cookies for optimal performance.`,
  },
];
